<!-- CODE -->
<div class="font-poppins">
  <!-- !detailVisible -->
  <nz-card   *ngIf="!createFolderVisible && !this.quickViewVisible" style="min-height: 400px">
    <div class="row m-b-10 d">
      <div class="col-lg-6">
        <div class="d-md-flex">
          <div class="m-b-10 m-r-10">
            <button
              *ngIf="selectedRootFolder"
              title="Go Back"
              (click)="goBack()"
              nz-button
              nzType="default"
            >
              <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
            </button>
          </div>
          <div class="m-b-10 m-r-10">
        <!-- (keyup)="onKeyUp(searchBox.value, selectedFolder)" -->
            <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
              <input
                type="text"
                nz-input
                placeholder="Search"
                
                #searchBox
                [(ngModel)]="searchTerm"
              />
              <!-- <ng-template #suffixTemplate (click)="resetSearch()">
              <i nz-icon nzType="search" class="opacity-05"></i>
            </ng-template> -->
            </nz-input-group>
            <ng-template #suffixTemplate>
              <a nz-icon class="opacity-05" (click)="searchTerm && resetSearch()">
                <i nz-icon nzType="close" class="opacity-05"></i>
              </a>
            </ng-template>

            <ng-template #prefixTemplate>
              <i nz-icon nzType="search" class="opacity-05"></i>
            </ng-template>
           
          </div>
          <div class="m-b-10 m-r-10">
                <button class="btn-fill" nz-button nzType="default" nzSize="small" (click)="applySearch(searchBox.value)"
                  [nzDisabled]="isLoading || !searchBox.value">
                  Search
                </button>
          </div>
          <div class="m-b-10 m-r-10">
            <button
            
              nz-button
              nz-popover
              [nzPopoverContent]="popoverContent"
              nzPopoverTrigger="click"
              nzPopoverPlacement="bottom"
              [(nzPopoverVisible)]="filterVisible"
              (nzPopoverVisibleChange)="onPopoverVisibleChange($event)"
              class="btn-outline resource-btn"
              style="text-align: center"
>
              <span *ngIf="this.active && this.isArchived">All Resources</span>

              <span *ngIf="!this.active && !this.isArchived">All Resources</span>
              <span *ngIf="this.active && !this.isArchived">Active</span>
              <span *ngIf="this.isArchived  && !this.active">Archived</span>

              <i
                nz-icon
                nzType="caret-down"
                style="position: relative; top: 1px; left: -3px"
                nzTheme="outline"
              ></i>
            </button>
            <ng-template
              class="filter"
              style="text-align: left; padding: 0px !important"
              #popoverContent
            >
              <div class="" [@fadeIn]   style=" padding-top: 10px;">
                <div nz-row nzGutter="24">
                  <div
                    nz-col
                    class="gutter-row"
                    nzSpan="24"
                    style="padding-bottom: 15px;"
                  >
                    <span class="filter-heading">Show resources that are</span>
                  </div>
                </div>
              </div>
              <div style="height: 80px" nz-row>
                <div
                  style="color: #2d2d35; font-family: Poppins !important"
                  nz-col
                  nzSpan="24"
                >
                  <!-- <label nz-checkbox [(ngModel)]="isUsedInLast30Days"
                    >Used in last 30 days</label
                  >
                  <nz-divider
                    style="
                      margin-top: 5px !important;
                      margin-bottom: 10px !important;
                    "
                  ></nz-divider> -->
                  <label nz-checkbox [(ngModel)]="active">Active</label>
                  <nz-divider
                    style="
                      margin-top: 5px !important;
                      margin-bottom: 10px !important;
                    "
                  ></nz-divider>
                  <label nz-checkbox [(ngModel)]="archived">Archived</label>
                </div>
              </div>
              <div nz-row>
                <div
                  nz-col
                  nzSpan="24"
                  class="d-flex align-items-center justify-content-between"
                >
                  <span (click)="clickFilter()" class="cancel-label"
                    >Cancel</span
                  >
                  <button
                    class="btn-fill"
                    nz-button
                    nzType="default"
                    nzSize="small"
                    (click)="applyFilters()"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </ng-template>
          </div>
     
        </div>
      </div>
      <div class="col-lg-6">
        <div class="d-md-flex justify-content-end">
          <!-- <div class="m-b-10 m-r-10">
            <nz-radio-group class="m-r-10">
              <label
                nz-radio-button
                nzValue="mailView"
                nzTooltipTitle="Mail View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i class="font-size-16" nz-icon nzType="mail" theme="fill"></i>
              </label>
              <label
                nz-radio-button
                nzValue="excelView"
                nzTooltipTitle="Excel View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="file-excel"
                  theme="fill"
                ></i>
              </label>
              <label
                nz-radio-button
                nzValue="printView"
                nzTooltipTitle="Print View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="printer"
                  theme="fill"
                ></i>
              </label>
            </nz-radio-group>
          </div> -->
          <!-- <div class="m-b-10 m-r-20">
            <nz-radio-group>
              <label
                nz-radio-button
                nzValue="cardView"
                nzTooltipTitle="Card View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="appstore"
                  theme="fill"
                ></i>
              </label>
            </nz-radio-group>
          </div> -->
          <div class="file-sync-time">
            <span> Last sync </span>
            <div class="last-sync">{{lastFileSyncTime | timezoneDate:currentBrowserTimeZone}}</div>
          </div>
            <button
            *ngIf="!this.isFileSyncingStatus"
            nz-button
            nzType="primary"
            class="sync-button"
           (click)="syncFileConfirmation()"
          >
            <span>
             <i nz-icon nzType="sync" nzTheme="outline" class="sync-icon pr-2 "></i></span
            >
            Sync files
          </button>
          
          <button 
            *ngIf="this.isFileSyncingStatus" 
            nz-button 
            nzType="primary" 
            class="sync-button disabled-style"
            [nzDisabled]="true"
            >
           
              Syncing files...
          </button>
          
          <button
            nz-button=""
            nztype=" primary"
            class="font-small-caps btn-custom-light"
            title="Delete"
            *ngIf="anyChecked"
            nz-wave="[object Object]"
            nz-popconfirm
            nzPopconfirmTitle="Deleting the selected folders and files will permanently remove them, including all nested subfolders and files within them."
            (nzOnConfirm)="deleteResource(null, true)"
            nzPopconfirmPlacement="bottom"
            [nzOverlayClassName]="'custom-popconfirm-size'"
            style="margin-right: 10px"
          >
            <i class="font-size-16" nz-icon nzType="delete" theme="fill"></i>
          </button>
          <button
            nz-button
            nzType="primary"
            nz-popover
            nzPopoverPlacement="bottomRight"
            nzPopoverTitle="New Resource"
            [(nzPopoverVisible)]="visible"
            nzPopoverTrigger="click"
            [nzPopoverContent]="contentTemplate"
            class="btn-fill"
          >
            <span>
              <i
                class="fa fa-plus button-plus-icon"
                aria-hidden="true"
              ></i></span
            >&nbsp;NEW
          </button>

          <ng-template #contentTemplate >
            <div nz-row class="font-poppins" style="width: 100%; height: 120px; " [@fadeIn]>
              <div style="color: #2d2d35" nz-col nzSpan="24">
                <div
                  class="new-btn-items"
                  style="justify-content: space-between;"
                  (click)="clickMe('file', 'fileParam')"
                  >
                    <i nz-icon nzType="desktop" nzTheme="outline"></i> 
                
                  Upload From Computer</div
                >
                <nz-divider></nz-divider>
                <div 
                class="new-btn-items"
                 (click)="clickMe('url', 'urlParam')"
                  >
                  <i nz-icon nzType="link" nzTheme="outline"></i> 
                    <span>Import from URL</span>
                    </div
                >
                <nz-divider></nz-divider>
                <div
                class="new-btn-items"
                  (click)="open()"
                  >
                <i nz-icon nzType="folder-add" nzTheme="outline"></i> 
                  Create Folder</div
                >
              </div>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- <nz-drawer
        [nzVisible]="quickViewVisible"
        [nzFooter]="Footer"
        nzPlacement="right"
        nzTitle="Add Resource"
        nzWidth="40%"
        (nzOnClose)="hideAddResourceDrawer()"
        [nzClosable]="true"
      >
        <ng-container *nzDrawerContent>
          <app-new-resource
            [selectedRootFolder]="selectedRootFolder"
            [updateMode]="updateMode"
            [rawUpdateResource]="fillEditResourceData"
            (hideDrawer)="hideAddResourceDrawer($event)"
            [childFunction]="getResources"
            (sendFormEvent)="receiveFormFromChild($event)"
            [initialValues]="fillEditResourceData"
            (metadataEvent)="getResourceList({ filters: [] })"
          ></app-new-resource>
        </ng-container>
      </nz-drawer> -->

    </div>



    <div nz-row >
      <div nz-col nzSpan="24">
      
        <div class="m-t-5">
    

            <!-- [nzVirtualItemSize]="300" -->
        <nz-spin [nzSpinning]="isLoading" nzTip="Loading...">
            <div 
              #scrollContainer
              class="table-wrapper"
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="150"
              (scrolled)="onScrollDown()"
              scrollWindow="false"
              style="height: calc(100vh - 170px); overflow-y: auto; overflow-x: hidden !important;"
              (scroll)="onScroll($event)"
              cdkScrollable
              
              >
              <!-- style="height: 400px; overflow: auto" -->
              <!-- [nzData]="filteredResourcess" -->
              <!-- [nzData]="filteredResourcess" -->
              <!-- [nzTemplateMode]="true" -->
          <nz-table
            [nzScroll]="{ x: '100%' }"
            #tableContainer
            [nzData]="filteredResourcess"
            class="no-border-last table-container"
            [nzFrontPagination]="false"
            [nzShowPagination]="false"
            (nzQueryParams)="onSortChange($event)"
           
             >
            <!-- [nzDragSort]="true" -->
          
            <thead >
              <tr>
                <!-- nzLeft nzWidth="50px" -->
                <th  style="width: 40px; min-width: 40px;">
                  
                </th>
                <th nzWidth="40px">
                  <label
                    nz-checkbox
                    [(nzChecked)]="allChecked"
                    (nzCheckedChange)="checkAll($event)"
                    [nzIndeterminate]="indeterminate"
                    [nzDisabled]="this.isArchived || filteredResourcess?.length === 0"
                  ></label>
                </th>

                <ng-container *ngFor="let column of listOfColumns; let i=index" >
                  <!-- [nzLeft]="i < 1" -->
                    <!-- [nzSortFn]="sortColumn(column)" -->
                    <!-- (nzSortChange)="onSortChange($event)" -->
                  <th
                  *ngIf="column.name !== ''"
                  [hidden]="column.name === 'Actions' && isArchived"
                  [nzSortOrder]="column.sortOrder"
                  [nzColumnKey]="column.key"
                  [nzSortDirections]="column.sortDirections"
                  [nzWidth]="column.colWidth"
                  [nzRight]="column.name === 'Actions' && !isArchived" 
                  [nzSortFn]="column.Showsort"
                  [nzShowSort]="column.Showsort"
                  >
                   <!-- [nzLeft]="i < 1"  -->
                    
                    {{ column.name }} 
                  </th>
                  <th *ngIf="column.name === ''" [nzWidth]="column.colWidth">{{ column.name }}</th>
                </ng-container>
              </tr>
            </thead>
            <tbody [@fadeIn] cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListData]="filteredResourcess" class="drop-list">
              <!-- ngFor let-item [ngForOf]="filteredResourcess" -->
              <ng-template   
               ngFor let-item [ngForOf]="filteredResourcess"
                let-i="index"
               class="data-list">
                <tr
        
                   cdkDrag
                   [nzDragSort]="true"
                   cdkDragLockAxis="y"
                  (cdkDragMoved)="onDragMoved($event)"
                  style="cursor: pointer; position: relative;"
                  class="data-row cursor-move"
                  [ngStyle]="{'opacity': this.isArchived ? '0.7' : '1'}"
                >
                <!-- (cdkDragEnded)="onDragEnded($event)"
                (cdkDragStarted)="onDragStarted($event)" -->
                  <ng-container>
                    <td class="w-2" cdkDragHandle > 
                      <img class="drag-icon" alt="" src="assets/images/logo/drag_indicator.svg">
                    </td>
                    <td >
                      <label
                        class="m-r-4"
                        nz-checkbox
                        [(nzChecked)]="item.checked"
                        [nzIndeterminate]="item.mixedState"
                        (nzCheckedChange)="onCheckboxChange(item)"
                        [nzDisabled]="this.isArchived"
                        
                      ></label>
                    </td>
                    <td class="positionBox" >
                      <div style="border:2px solid rgb(240 240 240 / 46%); " class="editable-cell" [hidden]="editId === item.resource_id" (click)="startEdit(item.resource_id)">
                        {{item.index}}
                      </div>
                      <input class="" [hidden]="editId !== item.resource_id" type="number"  nz-input [(ngModel)]="item.index" (blur)="stopEdit(item.index, $event,item)" (keydown.enter)="onEnter($event, item.index, item)" />
                    </td>
                    <td 
                    (click)="displayFolder(item, getBreadcrumbs())"
                    (dblclick)="displayFiles(item, getBreadcrumbs())"
                    >
                      <div class="d-flex align-items-center">
                        <div
                          class=""
                          style="cursor: pointer"
                          [ngClass]="{ active: selectedFile == item.name }"
                          (contextmenu)="
                            contextMenu($event, contextDropdownTpl, item.name)
                          "
                          [ngClass]="{ active: selectedFile == item.name }"
                        >
                          <div class="font-size-20"  style="line-height: 0; display: flex; justify-content: center; align-items: center; width: 40px; height: 40px;">
                            <!-- Folder -->
                            <i
                              *ngIf="item.is_folder === 1"
                              [twoToneColor]="colorGold"
                              nz-icon
                              nzType="folder-open"
                              theme="twotone"
                            ></i>
                            <!-- PDF -->
                            <ng-container *ngIf="item.is_folder === 0">
                              <nz-avatar 
                                *ngIf="item.resource_thumbnail && item.resource_path && getFileIcon(item.resource_path) === 'file-pdf'"
                                [nzShape]="'square'"                              
                                [nzSrc]="thumbnailBaseURL + item.resource_thumbnail">
                              </nz-avatar>
                              <i
                                *ngIf="!item.resource_thumbnail && item.resource_path && getFileIcon(item.resource_path) === 'file-pdf'"
                                [twoToneColor]="colorRed"
                                nz-icon
                                nzType="file-pdf"
                                theme="twotone"
                              ></i>
                              <!-- <i
                                *ngIf="
                                  getFileIcon(item.resource_path) ===
                                  'file-word'
                                "
                                [twoToneColor]="colorBlue"
                                nz-icon
                                nzType="file-word"
                                theme="twotone"
                              ></i> -->
                              <!-- <i
                                *ngIf="
                                  getFileIcon(item.resource_path) ===
                                  'file-excel'
                                "
                                [twoToneColor]="colorCyan"
                                nz-icon
                                nzType="file-excel"
                                theme="twotone"
                              ></i> -->

                              <!-- Image -->
                              <nz-avatar 
                              *ngIf="item.resource_path && getFileIcon(item.resource_path) === 'file-image'"
                              [nzShape]="'square'"
                                
                              [nzSrc]="thumbnailBaseURL + item.resource_path">
                              
                              </nz-avatar>
                              <!-- <idrf
                              *ngIf=" && (item.resource_path && getFileIcon(item.resource_path) === 'file-image')"
                            >
                            <nz-avatar nzIcon="user" nzSrc={{item.resource_url}} nzSize="small"></nz-avatar>
                          </idrf> -->
                            <!-- For link  -->
                            <span style="width: 40px;
                            height: 40px;
                            display: flex;
                            align-items: center;
                            justify-content: center;" *ngIf="item.resource_url != null && (item.size == null || item.size === '') && item.resource_path == ''
                              " nz-icon nzType="link" nzTheme="outline"></span> 
                            <!-- For video  -->

                              <i
                                *ngIf="!item.resource_thumbnail && 
                                item.resource_path && getFileIcon(item.resource_path) ===
                                  'file'
                                "
                                [twoToneColor]="colorCyan"
                                nz-icon
                                nzType="play-circle"
                                theme="twotone" 
                              ></i>
                              <nz-avatar 
                              *ngIf="item.resource_thumbnail && item.resource_path && getFileIcon(item.resource_path) === 'file'"
                              [nzShape]="'square'"
                                
                              [nzSrc]="thumbnailBaseURL + item.resource_thumbnail">
                              
                              </nz-avatar>
                              
                            </ng-container>
                          </div>
                        </div>

                        <span class="long-text m-l-10 m-b-0" style="display:flex; flex-direction: column; justify-content: center;height: 100%; ">{{
                          item.resource_name
                        }}
                        <p *ngIf="item.size" style="color:#98A4AE; font-size: 13px; margin: 0px;">File size:  {{ item.size }}</p>
                        <!-- <p *ngIf="!item.size" style="color:#98A4AE;  font-size: 13px; margin: 0px;">File size:  N/A</p> -->
                      </span>

                        <!-- <span *ngIf="!item.size">-</span> -->
                       
                        <!-- <span *ngIf="item.size" class="file-size"> ({{ item.size }}) </span> -->
                      </div>
                    </td>
                    <!-- Categories -->
                    <td (click)="displayFolder(item, getBreadcrumbs())"
                    (dblclick)="displayFiles(item, getBreadcrumbs())"
                    >
                      <span *ngIf="!item.category_name">-</span>
                      {{ item.category_name }}
                    </td>
                    <!-- Active -->
                    <td >
                      <!-- <span class="data-row-action"> -->
                        <span class="">
                        <nz-switch
                          [(ngModel)]="item.is_active"
                          [nzControl]="true"
                          (click)="clickSwitch($event,item)"
                          [nzLoading]="loadingSwitch"
                          nzSize="small"
                          [nzDisabled]="this.isArchived"
                          
                        ></nz-switch>
                      </span>
                    </td>

                    <!-- upload by -->
                    <td (click)="displayFolder(item, getBreadcrumbs())" (dblclick)="displayFiles(item, getBreadcrumbs())">{{ item.uploaded_date | date:'MM/dd/yyyy'}}</td>
                    
                    <!-- Popularity -->
                    <!-- <td>
                      <nz-badge
                        *ngIf="item.popularity === 'high'"
                        nzStatus="success"
                      ></nz-badge>
                      <nz-badge
                        *ngIf="item.popularity === 'Medium'"
                        nzStatus="error"
                      ></nz-badge>
                      <nz-badge
                        *ngIf="item.status === 'Not enough data'"
                        nzStatus="processing"
                      ></nz-badge>
                      <span *ngIf="!item.popularity" class="text-capitalize">
                        <nz-badge nzStatus="success">high</nz-badge></span
                      >
                    <span class="text-capitalize">high</span>
                    </td> -->
                    <td>
                      <!-- <span class="data-row-action"> -->
                      <span class="">
                        <nz-switch [(ngModel)]="item.is_shareable" [nzControl]="true" (click)="clickSwitchFileShare($event,item)"
                          [nzLoading]="loadingSwitch" nzSize="small" [nzDisabled]="this.isArchived || item.is_folder == 1"></nz-switch>
                      </span>
                    </td>
                    

                    <!-- Tags -->
                    <!-- <td (click)="displayFolder(item, getBreadcrumbs())" (dblclick)="displayFiles(item, getBreadcrumbs())">
                      <ng-container *ngIf="item.tag && item.tag.length > 0">
                        <ng-container
                          *ngIf="item.tag.length <= 2; else moreTags"
                        >
                          <nz-tag
                            *ngFor="let tag of item.tag.slice(0, 2)"
                            [nzMode]="default"
                            [nzColor]="'#ededed'"
                          >
                            {{ tag.tag_name }}
                          </nz-tag>
                        </ng-container>
                        <ng-template #moreTags>
                          <span *ngFor="let tag of item.tag.slice(0, 2)">
                            <nz-tag [nzMode]="default" [nzColor]="'#ededed'">{{
                              tag.tag_name
                            }}</nz-tag>
                          </span>

                          <span
                            nz-popover
                            [nzPopoverContent]="moreContents"
                            nzPopoverPlacement="bottom"
                            (mouseenter)="updateMoreTagsContent(item.tag)"
                            (mouseleave)="resetMoreTagsContent()"
                          >
                            <nz-tag [nzMode]="default" [nzColor]="'#ededed'"
                              >+{{ item.tag.length - 2 }} more</nz-tag
                            >
                          </span>

                          <ng-template #moreContents>
                            <span *ngFor="let tag of moreTagsContent">
                              <nz-tag
                                [nzMode]="default"
                                [nzColor]="'#ededed'"
                                >{{ tag }}</nz-tag
                              >
                            </span>
                          </ng-template>
                        </ng-template>
                      </ng-container>
                    </td> -->
                    <!-- File Size -->
                    <!-- <td>
                      <span *ngIf="!item.size">-</span>
                      <span *ngIf="item.size">{{ item.size }}</span>
                    </td> -->
                      <!-- Assignment -->
                    <td (click)="displayFolder(item, getBreadcrumbs())" (dblclick)="displayFiles(item, getBreadcrumbs())">
                      <span *ngIf="item.group_names.length <= 0">-</span>
                      <div class="d-flex align-items-center">
                        <div *ngIf="item.group_names.length > 0">
                          <nz-avatar
                            [nzSize]="30"
                            nzIcon="user"
                            [nzSrc]="item.avatar"
                          ></nz-avatar>
                        </div>

                        <span class="m-l-10 m-b-0">
                          <ng-container
                            *ngIf="
                              item.group_names.length <= 2;
                              else moreGroups
                            "
                          >
                            {{ item.group_names.join(", ") }}
                          </ng-container>

                          <ng-template #moreGroups>
                            {{ item.group_names.slice(0, 2).join(", ") }},
                            <span
                              nz-popover
                              [nzPopoverContent]="moreContent"
                              nzPopoverTrigger="hover"
                              nzPopoverPlacement="bottom"
                              nzEllipsis
                            >
                              {{ item.group_names.length - 2 }} more
                            </span>

                            <ng-template #moreContent nzEllipsis>
                              {{ item.group_names.slice(2).join(", ") }}
                            </ng-template>
                          </ng-template>
                        </span>
                      </div>
                    </td>
                
                    <!-- <td>
                      <nz-tag
                        *ngFor="let tag of item.tag; let i = index"
                        [nzMode]="default"
                        [nzColor]="'#ededed'"
                      >
                        {{ tag.tag_name }}
                      </nz-tag>
                    </td> -->
                  
                    
                    <td *ngIf="!this.isArchived" nzRight>
                      <!-- comment code -->
                      <!-- <span class="data-row-action">
                        <a
                          class="m-r-5"
                          nz-button
                          nzType="default"
                          nzShape="circle"
                          nz-tooltip
                          nzTooltipTitle="Edit"
                        >
                          <i
                            nz-icon
                            nzType="edit"
                            theme="outline"
                            (click)="fillEditResource(item)"
                          ></i>
                        </a>
                        <button
                          nz-button
                          nzType="default"
                          nzShape="circle"
                          nz-tooltip
                          nzTooltipTitle="Delete"
                        >
                          <i
                            nz-icon
                            nzType="delete"
                            theme="outline"
                            nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want to delete this resource?"
                            (nzOnConfirm)="deleteResource(item)"
                          ></i>
                        </button>
                      </span> -->
                      <!-- comment code -->
                        <!-- <i
                          nz-icon
                          nzType="edit"
                          nzTheme="outline"
                          (click)="fillEditResource(item)"
                          style="margin-left: 10px"
                          class="editIcon"
                        ></i>

                        <i
                          nz-icon
                          nzType="delete"
                          theme="outline"
                          nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want to delete this resource?"
                          (nzOnConfirm)="deleteResource(item)"
                          class="editIcon"
                        ></i> -->
                      <!-- </span> -->

                      <span style="display: flex; align-items: center; justify-content: space-between;">
                        <a
                        class="m-r-5"
                        nz-button
                        nzType="default"
                        nzShape="circle"
                        nz-tooltip
                        nzTooltipPlacement="bottom"
                        nzTooltipTitle="Edit"
                        (click)="fillEditResource(item)"
                        >
                        <i
                          nz-icon
                          nzType="edit"
                          theme="outline"
                        ></i>
                        </a>

                        <button
                        *ngIf="item?.is_folder"
                        nz-button
                        nzType="default"
                        nzShape="circle"
                        nzTooltipPlacement="bottom"
                        nz-tooltip
                        nzTooltipTitle="Delete"
                        (click)="$event.stopPropagation()"
                        nz-popconfirm
                        nzPopconfirmTitle="Deleting this folder will permanently remove all its nested files and subfolders. Are you sure you want to proceed?"
                        (nzOnConfirm)="deleteResource(item)"
                        [nzPopoverOverlayClassName]="'delete-popup'"
                        (nzOnCancel)="cancel()"
                      >
                        <i
                          nz-icon
                          nzType="delete"
                          theme="outline"
                   
                        ></i>
                        </button>
                        <button
                        *ngIf="!item?.is_folder"
                        nz-button
                        nzType="default"
                        nzShape="circle"
                        nzTooltipPlacement="bottom"
                        nz-tooltip
                        nzTooltipTitle="Delete"
                        (click)="$event.stopPropagation()"
                        nz-popconfirm
                        nzPopconfirmTitle="Are you sure you want to delete this resource?"
                        (nzOnConfirm)="deleteResource(item)"
                        (nzOnCancel)="cancel()"
                      >
                        <i
                          nz-icon
                          nzType="delete"
                          theme="outline"
                   
                        ></i>
                        </button>
                      </span>
                    </td>
                    <!-- <div class="hiddenEditDiv data-row-action" style="display: flex;">
                      <div style="display: flex; align-items: center; justify-content: space-between;">
                        <div style="display: flex; align-items: center; justify-content: space-between;">
                            <a
                              class="m-r-5"
                              nz-button
                              nzType="default"
                              nzShape="circle"
                              nz-tooltip
                              nzTooltipPlacement="bottom"
                              nzTooltipTitle="Edit"
                           
                              
                            >
                              <i
                                nz-icon
                                nzType="edit"
                                theme="outline"
                                (click)="fillEditResource(item)"
                              ></i>
                            </a>
                            <button
                              nz-button
                              nzType="default"
                              nzShape="circle"
                              nzTooltipPlacement="bottom"
                              nz-tooltip
                              nzTooltipTitle="Delete"
                            >
                              <i
                                nz-icon
                                nzType="delete"
                                theme="outline"
                                nz-popconfirm
                                nzPopconfirmTitle="Are you sure you want to delete this resource?"
                                (nzOnConfirm)="deleteResource(item)"
                              ></i>
                            </button>
                        </div>
                      </div>
                    </div> -->
                  </ng-container>
                      <!-- Add a placeholder for smooth dragging -->
                  <!-- <ng-template cdkDragPlaceholder>
                    <tr class="data-row placeholder-row">
                        <td colspan="100%">&nbsp;</td>
                    </tr>
                  </ng-template> -->
                </tr>
        
              </ng-template>
            
            </tbody>
          </nz-table>
       
        
        </div>
        </nz-spin>
        
        </div>
      </div>
    </div>


  </nz-card>

  <nz-card *ngIf="createFolderVisible">
    <nz-spin [nzTip]="isLoading ? 'Please wait...' : 'Please wait...'" [nzSpinning]="isLoading">
        <div nz-row nzGutter="16">
        <div
          nz-col
          class="gutter-row"
          nzSpan="24"
          style="text-align: right; width: 100%; height: 20px"
        >
          <a
            title="Cancel"
            (click)="this.checkFormState()"
            style="float: right; margin-bottom: 20px"
            ><i nz-icon nzType="close" theme="outline"></i
          ></a>
        </div>
        </div>
        <!-- <div class="form-container" [class.disabled]="isLoading"> -->
        <form nz-form nzLayout="vertical" [formGroup]="resourceFolderForm" >
          <div nz-row>
            <div nz-col nzSpan="11">
              <nz-form-item>
            <nz-form-label nzRequired>Folder Name</nz-form-label>
            <nz-form-control
              _ngcontent-jfp-c14=""
              class="ng-tns-c16-67 ant-form-item-control-wrapper ng-star-inserted ant-col-24"
            >
              <div class="ant-form-item-control">
                <span class="ant-form-item-children">
                  <input
                    formControlName="resource_name"
                    _ngcontent-jfp-c14=""
                    nz-input=""
                    placeholder="Folder Name"
                    nzSize="medium"
                    class="ant-input ng-untouched ng-pristine ng-invalid" /><span
                    class="ant-form-item-children-icon"
                  >
                  </span
                ></span>
              </div>
            </nz-form-control>
              </nz-form-item>
            </div>
    
            <div nz-col nzSpan="2">&nbsp;</div>
    
            <div nz-col nzSpan="11">
              <nz-form-item>
                <nz-form-label for="Tag"> Tags</nz-form-label>
                <nz-form-control>
                  <nz-select
                    formControlName="tag"
                    nzPlaceHolder="Please select"
                    nzSize="small"
                    nzMode="tags"
                    style="height: auto!important;"
                  >
                    <nz-option
                      *ngFor="let option of tagFilterList"
                      [nzLabel]="option.text"
                      [nzValue]="option.value"
                    ></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="11">
              <nz-form-item>
                <nz-form-label for="position" nzRequired> Position</nz-form-label>
               
                <nz-input-number formControlName="position" nzMin="1" nzMax="1000000" >
                  
                </nz-input-number>
                
              </nz-form-item>
            </div>
    
        
          
          </div>
        </form>
        <!-- Loading overlay -->
        <!-- <div class="overlay" *ngIf="isLoading"></div> -->
    
        <div nz-col nzSpan="24">
      
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
          "
        >
          <div nz-col nzSpan="12">
            <button
            *ngIf="!updateModes"
            (click)="resetResourceFolderForm()"
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-default"
              nz-wave="[object Object]"
            >
              <!----><span>Reset</span>
            </button>
            <button
            *ngIf="updateModes"
            (click)="resetResourceUpdateForm()"
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-default"
              nz-wave="[object Object]"
            >
              <!----><span>Reset</span>
            </button>
          </div>

          <div nz-col nzSpan="12" style="text-align: right">
            <button
            nz-button=""
            nztype="default"
            class="cancelbtn-outline"
            (click)="this.checkFormState()"
          >
            <span>Cancel</span>
          </button>
            <button
              nz-button=""
              nztype="default"
              *ngIf="!updateModes"
              class="ant-btn ant-btn-primary m-l-10"
              style="padding-left: 25px; padding-right: 25px"
              [nzLoading]="isLoading"
            (click)="submitFolder()"
            [disabled]="!this.resourceFolderForm.valid"
            >
              <span>Save</span>
            </button>

            <button
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-primary m-l-10"
              style="padding-left: 25px; padding-right: 25px"
              [nzLoading]="isLoading"
            (click)="updateFolder()"
            *ngIf="updateModes"
            [disabled]="!this.resourceFolderForm.valid"
            >
              <span>Update</span>
            </button>
          </div>
        </div>
        </div>
    </nz-spin>
  </nz-card>

  <nz-card *ngIf="quickViewVisible">
    <!-- <app-new-resource
        [selectedRootFolder]="selectedRootFolder"
        [updateMode]="updateMode"
        [rawUpdateResource]="fillEditResourceData"
        (hideDrawer)="hideAddResourceDrawer($event)"
        [childFunction]="getResources"
        (sendFormEvent)="receiveFormFromChild($event)"
        [initialValues]="fillEditResourceData"
        (metadataEvent)="getResourceList({ filters: [] })"
        >
      </app-new-resource> -->
      
      <!-- Add URL Forum -->
      <app-new-resource
      [selectedRootFolder]="selectedRootFolder"
      [updateMode]="updateMode"
      [rawUpdateResource]="fillEditResourceData"
      (hideDrawer)="hideAddResourceDrawer($event)"
      [childFunction]="applyFilters"
      (sendFormEvent)="receiveFormFromChild($event)"
      [initialValues]="fillEditResourceData"
      (metadataEvent)="getResourceList({ filters: [] })"
      *ngIf="isUrl && !isFile" 
      [url]="url"
      [filteredResourcess]="filteredResourcess">
  </app-new-resource>
  <!-- Add File forum  -->
  <app-new-resource
      *ngIf="isFile && !isUrl"
      [selectedRootFolder]="selectedRootFolder"
      [updateMode]="updateMode"
      [rawUpdateResource]="fillEditResourceData"
      (hideDrawer)="hideAddResourceDrawer($event)"
      [childFunction]="applyFilters"
      (sendFormEvent)="receiveFormFromChild($event)"
      [initialValues]="fillEditResourceData"
      (metadataEvent)="getResourceList({ filters: [] })"
      [filteredResourcess]="filteredResourcess"
      [file]="file">
  </app-new-resource>
  
  </nz-card>
</div>